import Chip from "@mui/material/Chip";
import { FP } from "./tokens";

const VARIANTS = {
  success: { bg: FP.color.successSoft, fg: FP.color.successDark, border: "#BBF7D0" },
  info: { bg: FP.color.infoSoft, fg: "#075985", border: "#BAE6FD" },
  warning: { bg: FP.color.warningSoft, fg: "#92400E", border: "#FCD34D" },
  danger: { bg: FP.color.dangerSoft, fg: "#9F1239", border: "#FECDD3" },
  neutral: { bg: FP.color.surfaceAlt, fg: FP.color.textSecondary, border: FP.color.border },
};

// Pill-style status badge used in tables and headers.
export default function StatusPill({ label, variant = "neutral", size = "small", sx = {}, ...rest }) {
  const v = VARIANTS[variant] || VARIANTS.neutral;
  return (
    <Chip
      size={size}
      label={label}
      sx={{
        height: 22,
        bgcolor: v.bg,
        color: v.fg,
        border: `1px solid ${v.border}`,
        fontWeight: 700,
        fontSize: "0.68rem",
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        "& .MuiChip-label": { px: 1.1 },
        ...sx,
      }}
      {...rest}
    />
  );
}
